import React from 'react';

// Simple PIX badge SVG
const PixBadge = ({ style, ...props }) => (
  <svg width="44" height="20" viewBox="0 0 44 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={style} {...props}>
    <rect x="0.5" y="0.5" width="43" height="19" rx="9.5" fill="#fff" stroke="#14B88D" strokeWidth="1.2" />
    <g>
      <rect x="6" y="4" width="12" height="12" rx="6" fill="#14B88D" />
      <path d="M10.5 10l2.5 2.5 2.5-2.5-2.5-2.5-2.5 2.5z" fill="#fff" />
    </g>
    <text x="22" y="14.5" textAnchor="middle" fontFamily="inherit" fontWeight="bold" fontSize="11" fill="#14B88D">PIX</text>
  </svg>
);

export default PixBadge;
